import EmptyCartIcon from '@/assets/EmptyCartIcon';
import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import BuyRentSelector from './Widgets/BuyRentSelector';

const EmptyCart = () => (
	<FlexBox
		direction='column'
		id='empty-cart'
		fullWidth
		alignItems={'center'}
		justifyContent='center'
	>
		<FlexBox justifyContent='center' sx={{ marginBottom: '8px', width: '35%' }}>
			{/* <EmptyCartIcon /> */}
		</FlexBox>
		<FlexBox
			fullWidth
			direction='column'
			alignItems={'center'}
			justifyContent={'center'}
		>
			<LencoTypography
				sx={{
					...getStyle('H14_Medium'),
					color: getColor('Gray 0'),
					marginBottom: '2px',
				}}
			>
				Your Cart Looks A little Empty!
			</LencoTypography>
			<LencoTypography
				sx={{ ...getStyle('P_Medium'), color: getColor('Gray -2') }}
			>
				Start Buying or Renting with us
			</LencoTypography>
			<Box mt='80px'>
				<EmptyCartIcon />
			</Box>
			<FlexBox
				fullWidth
				justifyContent={'space-between'}
				mt='24px'
				p='0px 60px'
			>
				<LencoTypography
					sx={{ ...getStyle('P_Medium'), color: getColor('Gray -2') }}
				>
					Looking to <br />
					BUY furniture?
				</LencoTypography>
				<LencoTypography
					sx={{ ...getStyle('P_Medium'), color: getColor('Gray -2') }}
				>
					Looking to <br />
					RENT furniture?
				</LencoTypography>
			</FlexBox>
			<FlexBox fullWidth mt='24px'>
				<BuyRentSelector />
			</FlexBox>
		</FlexBox>
	</FlexBox>
);

export default EmptyCart;
